import React from "react";
import { IMenu } from "../../V2/types/menuTypes";
import Form from "../Form";
import List from "../List";
import { MenuFormRender } from "../../V2/shared/FormHandler";
import { Route, RouteComponentProps, useParams } from "react-router-dom";
import { NotAuthorized } from "../NotAuthorized";

interface IProps {
    defaultListOfMenus: IMenu[];
}

export function DynamicRoutes({ defaultListOfMenus }: IProps) {
    return (
        <>
            <Route
                path="/l/:name"
                render={(props: any) => <HandleDynamicRoute defaultListOfMenus={defaultListOfMenus} {...props} />}
            />
            <Route
                path="/f/:name"
                render={(props: any) => (
                    <HandleDynamicRoute defaultListOfMenus={defaultListOfMenus} {...props} isFormV1={true} />
                )}
            />
            <Route
                path="/f2/:name/:id?"
                render={(props: any) => <HandleDynamicRoute defaultListOfMenus={defaultListOfMenus} {...props} />}
            />
        </>
    );
}

interface HandleDynamicRouteProps extends RouteComponentProps {
    defaultListOfMenus: IMenu[];
    isFormV1?: boolean;
}

interface RouteParams {
    name: string;
}

const HandleDynamicRoute: React.FC<HandleDynamicRouteProps> = ({ defaultListOfMenus, isFormV1 = false, ...props }) => {
    const { name } = useParams<RouteParams>();

    if (defaultListOfMenus.length === 0) {
        return <span>Loading...</span>;
    }

    const menu = defaultListOfMenus.find((menu) => menu.webaccao === name);

    if (!menu) {
        return <NotAuthorized />;
    }

    if (menu.webtipo === "FORMULARIO") {
        return isFormV1 ? (
            <Form
                justSee={undefined}
                formId={undefined}
                onSave={undefined}
                onCancel={undefined}
                params={undefined}
                updateOnSave={undefined}
                processFix={undefined}
                setJustSeeInPopup={undefined}
                listName={undefined}
                {...props}
            />
        ) : (
            <MenuFormRender onSave={() => {}} isInModal={false} {...props} />
        );
    } else if (menu.webtipo === "LISTA") {
        return <List {...props} />;
    }

    return <NotAuthorized />;
};
